import api from "../../axios";

export const getProjectName  = async () =>{
    return await api.get("/api/Orbit/Orbit/GetProjectName");
};

export const CreateExternalTicket = async (data) =>{
    return await api.post("/api/Orbit/Orbit/CreateTicket",
        data,{
            headers: {
                "Content-Type": "multipart/form-data"
            },
        }
    );
};
